export default function TableHeaderUnsortedIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 11.9998V3H5.25V11.9998H3L6 15L9 11.9998H6.75Z"
        fill="currentColor"
      />
      <path d="M12 3L9 6H11.25V15H12.75V6H15L12 3Z" fill="currentColor" />
    </svg>
  );
}
